<template>
    <div style="height: 100%;overflow:hidden; ">
        <!--<button @click="testPermission" style="position: fixed;top: 0px;left: 0px;z-index: 9999;">권한 체크</button>-->
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: 'App',
    components: {
        // HelloWorld
    },
    data() {
        return {
            device: null
        }
    },
    methods : {
    },
    created() {
        setTimeout(() => {
            // this.$GlobalStore.addModal('TestModal')
        }, 3000)

    }
}
</script>
<style>
:root {
    --global-font-family: NotoSansKorea, san-serif;
    --color-main: #ff7100;
    --color-main-user: #ff7100;
    --color-main-coach: #699BF7;
    --color-tab: #101014;
    --color-tab-font: white;
    color: #101014
}

.set_full_screen {
    padding-top: 0px !important;
}

.hide_scroll {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.hide_scroll::-webkit-scrollbar {
    display: none;
}

img {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
}
</style>
<style scoped></style>
